module.exports = __webpack_public_path__ + "static/FoundryGridnik-Regular-b73be9babc83f23a31802560b537474f.woff";